import React from 'react';
import coin2 from '../../data/img/coin1.png';
import Arrow_Right from '../../data/img/Arrow - Right.png';
import './Crypto.css';
import side_show_effect from './../../pages/side_show_effect';
const Crypto = () => {
    side_show_effect('.stake-container', '.stake-left', '.stake-right')
    return (
        <section id="crypto">
            <div className="container">
                <div className='stake-container'>
                    <div className='stake-left'>
                        <img src={coin2} alt="" />
                    </div>
                    <div className='stake-right'>
                            <h2>Stake altcoins nft</h2>
                            <p>The very first founders of the stake currency market were Sunny King and Scott Nadal. In 2012, they introduced Peer coin as the first virtual currency, the Blockchain, and the initial public offering of the ICO coin was organized in the same year. After changing and migrating to POS (Proof of Stake), network security was handed over to the stock proof algorithm.The stake means, keeping a certain amount of cryptocurrency in a wallet, blockchain, or even certain exchange offices and receiving a profit for it. It entails storing assets in a cryptocurrency wallet to finance a blockchain ...</p>
                            <button className='read-more-btn'>
                                Read <p>More<img src={Arrow_Right} alt=""/></p>
                            </button>
    	            </div>
                        
                </div>
            </div>
        </section>
    );
};

export default Crypto;